export const VideoCategorySkeleton = () => (
  <div className="animate-pulse">
    <div className="flex gap-5 w-full sm:flex-row flex-col">
      {/* Desktop: Featured Video (59.3%) */}
      <div className="sm:w-[59.3%] w-full">
        <div className="relative w-full aspect-video sm:h-[370px] h-[192px] rounded bg-neutral-200" />
      </div>

      {/* Desktop: Video List (40.7%) */}
      <div className="sm:w-[40.7%] w-full flex flex-col gap-5 sm:h-[370px] h-[348px] overflow-y-auto">
        {Array.from({ length: 5 }).map((_, idx) => (
          <div key={idx} className="flex gap-[15px]">
            {/* Video thumbnail with play icon placeholder */}
            <div className="relative sm:w-[25.8%] w-[26.1%] sm:h-[72px]">
              <div className="h-[72px] w-full rounded bg-neutral-200" />
            </div>
            {/* Video title and date */}
            <div className="sm:w-[74.2%] w-[73.9%] flex flex-col gap-1">
              <div className="h-4 w-full rounded bg-neutral-200" />
              <div className="h-3 w-2/3 rounded bg-neutral-200" />
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
)
